export default {
  getDate(dateString) {
    dateString =
      typeof dateString == "object" ? dateString : new Date(dateString);
    return dateString;
  },
  getDateString(date) {
    if (!date) return null;
    date = typeof date == "object" ? date : new Date(date);
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(date.getDate()).padStart(2, "0")}`;
  },
  getYearMonthString(date) {
    if (!date) return null;
    date = typeof date == "object" ? date : new Date(date);
    return date.toLocaleString("en-UK", { year: "numeric", month: "short" });
  },
  fixUTCDate(project) {
    delete project.createdAt;
    delete project.modifiedAt;
    project.approvedDate = project.approvedDate
      ? this.getDateString(project.approvedDate)
      : project.approvedDate;
    project.commencementDate = this.getDateString(project.commencementDate);
    project.completionDate = this.getDateString(project.completionDate);
    project.tasks.forEach((t) => {
      t.start = this.getDateString(t.start);
      t.end = this.getDateString(t.end);
    });
    project.equipments.forEach((e) => {
      e.startDate = this.getDateString(e.startDate);
      e.endDate = this.getDateString(e.endDate);
    });
    return project;
  },
};
